import {
    useEffect,
    useRef
} from 'react';

/* ========================================================================= */
/* Generic */
/* ========================================================================= */

/**
 * Access a previous state value
 * @param {any} value
 * @returns {any}
 */
export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

/**
 * A version of useEffect that will only fire on subsequent updates
 * @param {function} callback
 * @param {Array<any>} dependencies
 */
export const useEffectOnUpdate = (callback, dependencies) => {
    const didMount = useRef(false);
    useEffect(() => {
        if (didMount.current) {
            callback(dependencies);
        } else {
            didMount.current = true;
        }
    }, dependencies);
};
